import { DisplayTwilioParticipantType } from 'services/twilio/types';
import {
  PARTICIPANT_NAME_SYSTEM_ACTUAL,
  PARTICIPANT_NAME_SYSTEM_FRIENDLY,
  PARTICIPANT_SYSTEM_IMAGE,
} from 'constants/twilio';

export const defaultSystemParticipant: DisplayTwilioParticipantType = {
  name: PARTICIPANT_NAME_SYSTEM_FRIENDLY,
  identity: PARTICIPANT_NAME_SYSTEM_ACTUAL,
  imageUrl: PARTICIPANT_SYSTEM_IMAGE,
  subText: 'Cardian Angel ®',
};
